module.exports = __webpack_public_path__ + "static/media/sax-hot.d2a53747.svg";